import { Icon } from 'leaflet';

export const MapIcons = {
  STATUS_RED: new Icon({ iconUrl: '/icons/small/poi_red.png', iconSize: [32, 32] }),
  STATUS_YELLOW: new Icon({ iconUrl: '/icons/small/poi_yellow.png', iconSize: [32, 32] }),
  STATUS_GREEN: new Icon({ iconUrl: '/icons/small/poi_green.png', iconSize: [32, 32] })
};
